import React, { useState, useEffect } from "react";
import { CircularProgressCustom } from "./common-components/CircularProgressCustom";
import { useParams } from 'react-router-dom';
import { useQuery } from "@apollo/react-hooks";

import { GET_CATEGORIES, GET_TOTAL_PRODUCTS } from "../../services/graphql-query";

import Module_3 from "./HomeModules/Module_3";
import Module_4 from "./HomeModules/Module_4";
import Module_5 from "./HomeModules/Module_5";
import Module_2 from "./HomeModules/Module_2";

export default function Home() {

    const [isTotal, setTotal] = useState(20);
    const [isProducts, setProducts] = useState([]);
    const { productName } = useParams();

    const total_products = useQuery(GET_TOTAL_PRODUCTS);

    useEffect(() => {
        if (total_products.data) {
            setTotal(total_products.data.products.meta.pagination.total);
        }
    })

    const { loading, error, data } = useQuery(GET_CATEGORIES, {
        pollInterval: 300000, variables: { totalProducts: isTotal },
        onCompleted: (res) => {
            setProducts(res.categories.data);
        }
    });

    if (loading) return <CircularProgressCustom />;

    if (error)
        return (
            <>
                <h1>Sorry... We have some error</h1>
            </>
        );

    return isProducts.length === 0 ? (
        <h1>There are no products in stock</h1>
    ) : (
        <>
            {productName ? <Module_2 data={isProducts.filter((item) => item.attributes.name === productName)} /> : <Module_2 data={isProducts} />}

            {productName ? <></> : <div className="container-lg mx-auto mw-900">
                <Module_3 data={isProducts} />
                <Module_4 />
                <Module_5 />
            </div>}

        </>
    );
}
